/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Descriptions,
  Card,
} from 'antd';
import ReactJson from 'react-json-view';

import { getGatewayTransactionById } from '../../../redux/actions/Gateway';

const TransactionDetails = () => {
  const dispatch = useDispatch();
  const { transactionId } = useParams();
  const { gateway_transaction: { data } } = useSelector(({ gateway }) => gateway);

  useEffect(() => {
    if (transactionId) {
      dispatch(getGatewayTransactionById(transactionId));
    }
  }, [dispatch, transactionId]);

  return data && data._id ? (
    <div>
      <div className="justify-content-center">
        <Card title={data.kitegateway_reference}>
          <Descriptions>
            <Descriptions.Item label="Gateway Reference">{`${data.kitegateway_reference}`}</Descriptions.Item>
            <Descriptions.Item label="Ip address">{`${data.ip_address}`}</Descriptions.Item>
            <Descriptions.Item label="Level">{`${data.level}`}</Descriptions.Item>
            <Descriptions.Item label="message">{`${data.message}`}</Descriptions.Item>
            <Descriptions.Item label="Service Type">{`${data.service_type}`}</Descriptions.Item>
            <Descriptions.Item label="Processor name">{`${data.processor_name}`}</Descriptions.Item>
            <Descriptions.Item label="Procesor reference">{`${data.processor_reference}`}</Descriptions.Item>
            <Descriptions.Item label="Url">{`${data.url}`}</Descriptions.Item>
          </Descriptions>
          <Descriptions layout="vertical">
            <Descriptions.Item label="Kitegateway Collection Body" span={3}>
              <ReactJson src={data.request_body} collapsed />
            </Descriptions.Item>
            <Descriptions.Item label="Kitegateway Response Body" span={3}>
              <ReactJson src={data.response_body} collapsed />
            </Descriptions.Item>
            <Descriptions.Item label="Processor Request Body" span={3}>
              <ReactJson src={data.gateway_body} collapsed />
            </Descriptions.Item>

            <Descriptions.Item label="Processor Callback" span={3}>
              <ReactJson src={data.gateway_callback} collapsed />
            </Descriptions.Item>

            <Descriptions.Item label="Processor Response Body" span={3}>
              <ReactJson src={data.gateway_response} collapsed />
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </div>
    </div>
  ) : '';
};

export default TransactionDetails;
